import { Button } from '@smiles/voebiz-ui-kit';
import ModalInclude from 'components/ModalInclude';
import React, { useState } from 'react';
import ShowMoreIcon from 'components/Icons/ShowMoreIcon';
import { Tooltip } from 'components/Tooltip';
import { ITransactionPurchaseMiles } from '@smiles/voebiz-core-corporate-club/dist/Types/GetListPurchaseMiles.types';
import { useTransactions } from '../../../contexts/Transactions';
import SendMilesIcon from '../../Icons/SendMilesIcon';
import { TransactionStatus } from '../../../containers/Transactions/types';
import StatusPill from '../../StatusPill';

interface Transaction extends ITransactionPurchaseMiles {
  destination?: string;
  fileURL?: string;
}

const TableRow = () => {
  const { transactions, rewardCustomersIsEnabled } = useTransactions();

  const [showOptionsBtn, setShowOptionsBtn] = useState(false);

  const [openModalInclude, setOpenModalInclude] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState<number>();

  const isTransactionActive = (transaction: TransactionStatus) => transaction.status === 'Active';

  const handleDownloadFile = (index: number) => {
    setShowOptionsBtn(!showOptionsBtn);
    setSelectedIndex(index);
  };

  const handleShowInstructions = () => {
    setShowOptionsBtn(!showOptionsBtn);
    setOpenModalInclude(true);
  };

  const renderBtnOptions = (transaction: Transaction, index: number) => {
    if (index !== selectedIndex) {
      return null;
    }

    if (transaction.status === 'Concluído' || transaction.status === 'Erro parcial') {
      return (
        <Button
          key={`download-btn-${index}`}
          className="button-status-options btn-common-actions"
          icon={<SendMilesIcon />}
          onClick={() => {
            window.open(transaction.fileURL, '_blank');
            setShowOptionsBtn(!showOptionsBtn);
          }}
        >
          Baixar Arquivo
        </Button>
      );
    }
    if (transaction.status === 'Erro - Erro total' || transaction.status === 'Erro') {
      return (
        <Button
          key={`instructions-btn-${index}`}
          className="button-status-options btn-common-actions"
          icon={<SendMilesIcon />}
          onClick={handleShowInstructions}
        >
          Acessar instruções
        </Button>
      );
    }
    return null;
  };

  const handleCloseModalInclude = () => {
    setOpenModalInclude(false);
  };

  const [typeInclude, setTypeInclude] = useState('one');

  const handleTooltipErrorMessage = (status: string): string => {
    const ERROR_MESSAGE = {
      'Erro - Erro total': 'Corrija os erros e reenvie o arquivo',
      'Erro parcial': 'Baixe o arquivo para corrigir os erros',
    };

    return ERROR_MESSAGE[status] ? ERROR_MESSAGE[status] : '';
  };

  return (
    <>
      {transactions?.map((transaction: Transaction, index) => (
        <>
          <tr
            className={
              isTransactionActive(transaction) ? 'table-transactions-rows' : 'table-transactions-rows inactive'
            }
            key={transaction.amount}
            data-testid={`table-row-${index}`}
          >
            <td>{transaction.created}</td>
            <td>
              <Tooltip content={transaction.campaignName} direction="top">
                <span className="table-span">{transaction.campaignName}</span>
              </Tooltip>
            </td>
            {rewardCustomersIsEnabled && <td> {transaction.destination}</td>}
            <td>{transaction.type}</td>
            <td>{transaction.status !== 'Em processamento' ? transaction.amount : '-'}</td>
            <td>
              <Tooltip content={handleTooltipErrorMessage(transaction.status)} direction="bottom">
                <StatusPill status={transaction.status} />
              </Tooltip>
            </td>
            {!rewardCustomersIsEnabled && <td />}
            <td>
              {transaction.status !== 'Em processamento' && (
                <Tooltip content="Mais ações" direction="bottom">
                  <button
                    data-testid="show-more-button"
                    type="button"
                    className="show-more-btn"
                    key={`show-more-btn-${index}`}
                    onClick={() => handleDownloadFile(index)}
                  >
                    <ShowMoreIcon />
                  </button>
                </Tooltip>
              )}
            </td>
            <div className="button-wrapper">{showOptionsBtn && renderBtnOptions(transaction, index)}</div>
          </tr>
        </>
      ))}
      <ModalInclude
        isOpen={openModalInclude}
        closeModal={handleCloseModalInclude}
        setTab={setTypeInclude}
        type={typeInclude}
        instructionsModal
      />
    </>
  );
};

export default TableRow;
